import { useEffect, useState } from 'react';

const EVENT_ONLINE = 'online' as const;
const EVENT_OFFLINE = 'offline' as const;

function _window(): Window | undefined {
    return globalThis.window ?? undefined;
}

function _subscribeOnlineStatusChange(callback: (event: Event) => void) {
    const globalWindow = _window();

    globalWindow?.addEventListener(EVENT_ONLINE, callback);
    globalWindow?.addEventListener(EVENT_OFFLINE, callback);
}

function _unsubscribeOnlineStatusChange(callback: (event: Event) => void) {
    const globalWindow = _window();

    globalWindow?.removeEventListener(EVENT_ONLINE, callback);
    globalWindow?.removeEventListener(EVENT_OFFLINE, callback);
}

const _isOnline = () => (navigator ? navigator.onLine : false);

function useIsOnline(): boolean {
    const [isOnline, setIsOnline] = useState<boolean>(_isOnline());

    useEffect(() => {
        if (isOnline) {
            return;
        }

        const callback = () => {
            const newStatus = isOnline || _isOnline();
            setIsOnline(newStatus);
        };

        _subscribeOnlineStatusChange(callback);

        return () => {
            _unsubscribeOnlineStatusChange(callback);
        };
    });

    return isOnline;
}

export default useIsOnline;
